export const EVENT_TYPE = {
  bookingClick: "Booking click",
  breedGuideResults: "breedGuideResults",
  breedGuideResultSelected: "breedGuideResultSelected",
  campaignFormSubmitted: "CampaignForm submitted",
  campaignHybridFormSubmitted: "form_success",
  campaignPopupClick: "CampaignPopup clicked",
  event: "event",
  onlineBooking: "onlineBooking"
} as const;

export type EventType = (typeof EVENT_TYPE)[keyof typeof EVENT_TYPE];
